<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper" style="padding-bottom: 0rem">
        <div class="col-12">
          <button class="btn btn-sm btn-blue" v-if="current.tienda" @click="cambia_tipo()">
            <i class="fas fa-angle-double-left"></i>&nbsp; Regresar
          </button>
          <br><br>
          <div class="element-box mb-0">
            <div v-if="current.tienda" class="text-right">
              <button class="btn btn-blue btn-lg" data-toggle="modal" data-target="#modalRelacionarReq">
                Ligar Req. <i class="fas fa-paperclip	"></i>
              </button>
            </div>
            <br>
            <h5 class="form-header text-center">Traslado Directo de Localización</h5>
            <div class="text-center">
              <img style="width: 120px; height: 100px" id="base64image"
                src="data:image/png;base64,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" />
            </div>
            <div class="form-group">
              <br />
              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-4" id="select_inicio" style="display:none;">
                  <TiendaSelectComponent :current="current" />
                </div>
                <div v-if="current.tienda" class="row col-md-4">
                  <div class="col-9">
                    <label>Barra Producto / SKU</label>
                    <input v-on:keyup.enter="refreshProducto()" type="text" class="form-control"
                      v-model="current.barra" />
                  </div>
                  <div style="max-width: 50%; padding-right: 0px">
                    <br />
                    <button @click="refreshProducto()" class="btn btn-info btn-lg">
                      <i class="fas fa-search"></i>
                    </button>
                    <button @click="resetFilters()" class="btn btn-dark btn-lg">
                      <i class="fas fa-sync"></i>
                    </button>
                  </div>
                </div>
                <br>
                <div class="row col-12">
                  <div class="col-md-2"></div>
                  <div v-if="current.tienda" class="col-md-3">
                    <label>Barra Posición Origen</label>
                    <input type="text" class="form-control" v-model="current.posicion_origen" />
                  </div>
                  <div v-if="current.tienda" class="col-md-3">
                    <label>Barra Posición Destino</label>
                    <input type="text" class="form-control" v-model="current.posicion_destino" />
                  </div>
                  <div v-if="current.tienda" class="col-md-2">
                    <label>Cantidad (Unidades)</label>
                    <input type="text" class="form-control" v-model="current.cantidad" />
                  </div>
                </div>
                <div class="col-12 row">
                  <div class="col-6 fade" id="tipo_normal">
                    <button class="btn btn-success btn-lg btn-block btn-lg" @click="mostrar_tienda_select()">
                      <i class="fas fa-caret-right"></i>
                      Traslado Normal
                    </button>
                  </div>
                  <div class="col-6 fade" id="tipo_debaja">
                    <button class="btn btn-danger btn-lg btn-block btn-lg" @click="tipo_de_baja()">
                      Traslado para dar de Baja a Requerimiento
                      <i class="fas fa-caret-left"></i>
                    </button>
                  </div>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-2" v-if="current.producto.producto_obj"></div>
                <div class="col-8" v-if="current.producto.producto_obj" style="border-color: #d6d5d2; border: solid 1px lightgray;
">
                  <div>
                    <br>
                    <h5 class="text-success text-center" v-if="current.producto.producto_obj"><u>Detalle de Traslado</u>
                    </h5>
                    <span class="text-success" style="font-size: medium;">
                      Descripción de Producto:
                    </span>
                    <div class="row col-12">
                      <h6 class="text-blue text-left" v-if="current.producto.producto_obj"
                        style="font-size: 16px; letter-spacing: -1px;">
                        {{ current.producto.producto }} -
                        {{ current.producto.producto_obj.nombre }}
                      </h6>
                      &nbsp;&nbsp;
                      <span v-if="current.cantidad" style="font-size: 18px; letter-spacing: -1px;">/&nbsp; {{
                        current.cantidad
                      }} Unidades</span>
                    </div>
                  </div>
                  <div v-if="current.req_traslado_d" class="font-weight-bold text-blue" style="text-align: left;">
                    <span style="
                        font-size: 18px;
                        letter-spacing: -1px;
                      ">Se asoció el requerimiento #{{ current.numero_o_id }}
                      &nbsp;<i class="fas fa-check" style="color: #0e1b36;"></i>
                    </span>
                  </div>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-3"></div>
                <div class="col-6">
                  <button v-if="current.posicion_origen && current.posicion_destino" @click="generarTransaccion()"
                    class="btn btn-success btn-md btn-block btn-lg">
                    Generar Transacción <i class="fas fa-check"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Relacionar Req -->
    <div class="modal fade" id="modalRelacionarReq" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" style="padding-bottom: 0px">
            <h5 class="modal-title" id="exampleModalLabel">Cierre de Requerimiento</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding-top: 0px; text-align: justify">
            <div>
              <small>
                <span class="font-weight-bold">Nota:</span> La presente utilidad ligará y cerrará las
                unidades pendientes de un producto dentro del requerimiento al hacer el traslado de
                localización.</small>
            </div>
            <hr />
            <div class="row">
              <div class="col-12">
                <TiendaSelectComponent titulo="Tienda Origen" :current="current" />
              </div>
              <div class="col-12">
                <TiendaSelectComponent titulo="Tienda Destino" :current="current_" />
              </div>
              <div class="col-12">
                <label>Número o ID de requerimiento</label>
                <input type="text" v-model="current.numero_o_id" placeholder="#########" class="form form-control" />
              </div>

              <div class="col-12">
                <div class="modal-body">
                  <TrasladoLocDirectoTableComponent @setDataCurrent="setDataCurrent" :dataTabla="reqs_traslados"
                    :current="current" />
                </div>
              </div>
              <div class="col-12" style="text-align: center;">
                <button @click="buscarReqTraslado()" class="btn btn-lg btn-dark btn-lg">
                  Buscar &nbsp;<i class="fas fa-eye"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "@/services/commons/DynamicService";
import TrasladoLocDirectoTableComponent from "@/components/inventario/traslado_loc_directo/TrasladoLocDirectoTableComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProductoSelectComponentV2,
    TrasladoLocDirectoTableComponent,
  },
  data() {
    return {
      current_: {
        tienda: "",
      },
      reqs_traslados: "",
      numero: "",
      current: {
        producto: {
          nombre: "",
          producto_obj: "",
        },
        numero: "",
        numero_o_id: "",
        errors: {
          productos: null,
        },
      },
      datos: [],
      categorias: [],
    };
  },

  computed: {},
  mounted() {
    let self = this;
  },
  methods: {
    setDataCurrent(detalle) {
      let self = this;
      self.current.req_traslado_d = detalle;
      self.current.cantidad = detalle.cantidad_abierta;
      self.current.producto.producto = detalle.producto.sku;
      self.current.producto.producto_obj = detalle.producto;
      self.current.barra = detalle.producto.sku;
      self.current.req_traslado_d = detalle.id;
      self.reqs_traslados = [];
      $("#modalRelacionarReq").modal("hide");
      detalle = [];
    },
    buscarReqTraslado() {
      let self = this;
      DynamicService.getActionList("inv", "req_traslado", "buscar_req_x_numero_id", {
        tienda: self.current_.tienda,
        numero_o_id: self.current.numero_o_id,
      }).then((response) => {
        self.reqs_traslados = response.data;
      });
    },
    generarTransaccion() {
      let self = this;
      Notifications.alert.confirm(
        "Esta acción ejecutara el traslado del producto",
        "Este proceso no tiene retorno",
        "",
        function () {
          DynamicService.postActionList(
            "inv",
            "salida_localizacion",
            "trasferencias_directas",
            self.current,
          )
            .then((response) => {
              Notifications.alert.success(
                "Generar traslado de producto",
                "Realizado correctamente",
                ""
              );
              self.resetFilters();
              document.getElementById('select_inicio').style.display = "none",
                document.getElementById('tipo_normal').style.display = "block",
                document.getElementById('tipo_debaja').style.display = "block"
            })
            .catch((error) => {
              self.errors = error.response.data;
              Notifications.alert.error(
                "Generar traslado de producto",
                error.response.data.detail
              );
            });
        }
      );
    },
    resetFilters() {
      let self = this;
      self.current.posicion_origen = "";
      self.current.posicion_destino = "";
      self.current.tienda = "";
      self.current.cantidad = "";
      self.current.barra = "";
      self.current.producto.producto = "";
      self.current.producto.producto_obj = "";
      self.current_.tienda = "";
      if (self.current.req_traslado_d) {
        delete self.current.req_traslado_d;
      }

      self.current.numero_o_id = "";
    },
    imprimir() {
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=inventario/Req_traslados/solicitudes_por_tienda_sku.jrxml&producto_id=${this.current.producto.sku}&tienda_id=${this.current.tienda}`
      );
    },
    ver_requerimiento(id) {
      let self = this;
      let routeUrl = this.$router.resolve({
        name: "inventario-req_traslado-editar",
        params: { id: id },
      });
      window.open(routeUrl.href, "_blank");
    },
    cleanFilters() {
      this.current.numero = null;
      this.current.tienda = null;
      this.datos = "";
    },
    refreshProducto() {
      let self = this;
      DynamicService.fetch("cat", "producto-barra", {
        // barra: self.current.barra,
        "filter[search]": self.current.barra,
      }).then((response) => {
        self.current.producto = response.data.results[0];
      });
    },
    refresh() {
      let self = this;
      if (!self.current.numero || !self.current.tienda) {
        Notifications.alert.error(
          "Faltan campos",
          "El número y la tienda son campos obligatorios"
        );
        return;
      }
      DynamicService.getActionList("inv", "req_traslado", "obtener_analisis_reqs", {
        tienda: self.current.tienda,
        numero: self.current.numero,
      })
        .then((res) => {
          self.datos = res.data;
          console.log(self.datos);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
    mostrar_tienda_select() {
      document.getElementById('select_inicio').style.display = "block";
      document.getElementById('tipo_normal').style.display = "none";
      document.getElementById('tipo_debaja').style.display = "none";
    },
    tipo_de_baja() {
      let self = this;
      $("#modalRelacionarReq").modal("show");
      document.getElementById('select_inicio').style.display = "block";
      document.getElementById('tipo_normal').style.display = "none";
      document.getElementById('tipo_debaja').style.display = "none";
    },
    cambia_tipo() {
      location.reload();
    },
  },
};
</script>
